<template>
    <div>
        <v-text-field
            v-model="search"
            label="Cari"
            clearable
        ></v-text-field>

        <v-data-table
            @input="emitSelectedQuestions"
            v-model="selectedQuestions"
            :headers="headers"
            :items="filteredQuestions"
            :search="search"
            item-key="id"
            show-select
            dense
            :items-per-page="-1"
        >
            <template #item.used="{ value }">
                {{ value.map(i => i.period).join(',') }}
            </template>
        </v-data-table>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Array,
        },

        questions: {
            type: Array,
            default: () => []
        }
    },

    data: () => ({
        search: null,
        selectedQuestions: [],
        headers: [
            { text: '#', value: 'number', filterable: false },
            { text: 'Pertanyaan', value: 'question' },
            { text: 'Bidang', value: 'field' },
            { text: 'Digunakan', value: 'used', sortable: false, filterable: false }
        ]
    }),

    computed: {
        flattenedQuestion() {
            const result = []

            if (! this.questions) {
                return []
            }

            let number = 1
            for (const question of this.questions) {
                result.push({
                    id: question.id,
                    number,
                    question: question.question,
                    field: question.field.title,
                    used: question.tryoutQuestions?.map(tryoutquestion => ({
                        tryout: tryoutquestion.tryout.title,
                        period: tryoutquestion.tryout.period.title
                    }))
                })

                number++
            }

            return result
        },

        filteredQuestions() {
            return this.flattenedQuestion
        },

        selectedQuestionIds() {
            return this.selectedQuestions.map(question => question.id)
        }
    },

    methods: {
        emitSelectedQuestions() {
            this.$emit('input', this.questions.filter(question => this.selectedQuestionIds.includes(question.id)))
        },

        resetSelectedQuestions() {
            this.selectedQuestions = []
        }
    }
}
</script>
